import { useTranslation } from "react-i18next";
import "./InfoExtras.css";
import { useSelector } from "react-redux";

const InfoExtras = () => {
  // Feature Flags
  const isMedicCertificateEnabled = useSelector(
    (state) => state.featureFlag.extras.medicCertificate
  );
  const isExpressDeliveryEnabled = useSelector(
    (state) => state.featureFlag.extras.expressDelivery
  );
  const isOrdinaryMailDeliveryEnabled = useSelector(
    (state) => state.featureFlag.extras.ordinaryMailDelivery
  );

  const [t] = useTranslation("global");
  return (
    <div className="InfoExtras__container">
      {isMedicCertificateEnabled && (
        <div>
          <p>
            {t("EXTRAS.info.p_1.str_1")}
            <span> {t("EXTRAS.info.p_1.str_2")} </span>{" "}
            {t("EXTRAS.info.p_1.str_3")}
          </p>
          <p>{t("EXTRAS.info.p_2.str_1")}</p>
          <p>{t("EXTRAS.info.p_3.str_1")}</p>
        </div>
      )}
      {isExpressDeliveryEnabled && (
        <div>
          <p>
            {t("EXTRAS.info.p_4.str_1")}
            <span> {t("EXTRAS.info.p_4.str_2")} </span>{" "}
            {t("EXTRAS.info.p_4.str_3")}
          </p>
          <p>{t("EXTRAS.info.p_5.str_1")}</p>
        </div>
      )}
      {isOrdinaryMailDeliveryEnabled && (
        <div>
          <p>
            {t("EXTRAS.info.p_6.str_1")}
            <span> {t("EXTRAS.info.p_6.str_2")} </span>{" "}
            {t("EXTRAS.info.p_6.str_3")}
          </p>
        </div>
      )}
    </div>
  );
};

export default InfoExtras;
